import { createRouter, createWebHistory } from 'vue-router'
import prefixEve from 'src/utils/routeFilter.js'
const prefix = prefixEve.cuttingFiler()
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/ent/login',
      name: 'EnterpriseLogin',
      component: () => import('@/views/enterprise/login/index.vue'),
      meta: { title: '企业登录', hidden: true }
    },
    {
      path: '/ent/forgot',
      name: 'EnterpriseForgot',
      component: () => import('@/views/enterprise/login/forgot.vue'),
      meta: { title: '重置密码', hidden: true }
    },
    {
      // 免登录中转页（BOSS 企业列表「登录」新开页进入）：兑换 access_token 前无 token，需静态注册 + 白名单放行
      path: '/ent/impersonate',
      name: 'EnterpriseImpersonate',
      component: () => import('@/views/enterprise/impersonate/index.vue'),
      meta: { title: '登录跳转中', hidden: true }
    },
    {
      // 中台个人授权应用登录界面：OAuth 风格的授权同意页，外部应用带 client_id/redirect_uri/state 跳入
      // 企业端前缀路由：consent/profile 需 Bearer 令牌，未登录由守卫自动跳 /ent/login 并带 redirect 回跳
      path: '/ent/auth',
      name: 'EnterpriseAuth',
      component: () => import('@/views/enterprise/auth/index.vue'),
      meta: { title: '应用授权', hidden: true }
    },
    {
      path: '/boss/login',
      name: 'BossLogin',
      component: () => import('@/views/boss/login/index.vue'),
      meta: { title: '管理员登录', hidden: true }
    },
    {
      path: `${prefix}/home`,
      name: 'home',
      component: () => import('@/views/home.vue'),
      meta: { title: '首页', hidden: true }
    },
    {
      // 两端裸前缀入口（/ent、/ent/、/boss、/boss/）重定向到各自仪表盘首页，避免命中 404 兜底；
      // vue-router 默认 strict: false，一条记录同时匹配带/不带尾斜杠的形式
      path: '/ent',
      redirect: '/ent/dashboard/index',
      meta: { hidden: true }
    },
    {
      path: '/boss',
      redirect: '/boss/dashboard/index',
      meta: { hidden: true }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFoundView.vue'),
      meta: { title: '页面不存在' }
    }
  ]
})
export default router
